import { j as s } from "./atoms-v218.js";
import { forwardRef as S } from "react";
import { Root as l } from "./atoms-v2738.js";
import { Icon as j } from "./atoms-v217.js";
import { StyledTabsList as g, StyledTab as p, IconBox as c, StyledLabel as w } from "./atoms-v2739.js";
const b = S(
  ({ colorTheme: n = "light", onChange: a, selectedValue: d, size: $ = "small", tabs: h }, y) => {
    const T = (e) => {
      a == null || a(e);
    }, f = ({
      iconLeft: e,
      iconRight: i,
      isDisabled: x,
      isShrinkable: o,
      label: m,
      selectedValue: r,
      value: t
    }) => /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      e && /* @__PURE__ */ s.jsx(c, { children: /* @__PURE__ */ s.jsx(j, { name: e }) }),
      m && /* @__PURE__ */ s.jsx(
        w,
        {
          $colorTheme: n,
          $isDisabled: x,
          $isSelected: r === t,
          $isShrinkable: o,
          children: m
        }
      ),
      i && /* @__PURE__ */ s.jsx(c, { children: /* @__PURE__ */ s.jsx(j, { name: i }) })
    ] });
    return /* @__PURE__ */ s.jsx(l, { onValueChange: T, ref: y, value: d, children: /* @__PURE__ */ s.jsx(g, { $colorTheme: n, "aria-label": "Tabs", children: h.map(
      ({
        iconLeft: e,
        iconRight: i,
        isClickableOnly: x = !1,
        isDisabled: o = !1,
        isShrinkable: m = !1,
        label: r,
        value: t
      }) => x ? /* @__PURE__ */ s.jsx(
        p,
        {
          $colorTheme: n,
          $hasOwnLabel: typeof r != "string",
          $isDisabled: o,
          $isSelected: !1,
          $size: $,
          ...typeof r != "string" ? {
            asChild: !0,
            value: t
          } : {
            as: "button"
          },
          children: typeof r == "string" ? /* @__PURE__ */ s.jsx(
            f,
            {
              iconLeft: e,
              iconRight: i,
              isDisabled: o,
              isShrinkable: m,
              label: r,
              selectedValue: d,
              value: t
            }
          ) : r
        },
        t
      ) : /* @__PURE__ */ s.jsx(
        p,
        {
          $colorTheme: n,
          $hasOwnLabel: typeof r != "string",
          $isDisabled: o,
          $isSelected: d === t,
          $size: $,
          disabled: o,
          value: t,
          children: typeof r == "string" ? /* @__PURE__ */ s.jsx(
            f,
            {
              iconLeft: e,
              iconRight: i,
              isDisabled: o,
              isShrinkable: m,
              label: r,
              selectedValue: d,
              value: t
            }
          ) : r
        },
        t
      )
    ) }) });
  }
);
b.displayName = "Tabs";
export {
  b as Tabs
};
